module.exports = __webpack_public_path__ + "static/media/HCMM630.feedb0ee.jpg";